import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { testid: "stat-sessions", value: 500, suffix: "+", label: "Sessions delivered" },
  { testid: "stat-people", value: 15000, suffix: "+", label: "People reached" },
  { testid: "stat-orgs", value: 80, suffix: "+", label: "Organizations served" },
];

const format = (n) => n.toLocaleString("en-US");

const Counter = ({ value, suffix, run }) => {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!run) return;
    let raf;
    const duration = 1600;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(Math.round(eased * value));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [run, value]);

  return (
    <span>
      {format(display)}
      <span className="text-[#D4AF37]">{suffix}</span>
    </span>
  );
};

export const ImpactStrip = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });

  return (
    <section
      ref={ref}
      className="relative z-10 border-y border-[#AEE6D5]/12 bg-[#0A2E2C] px-6 py-14 sm:px-10 lg:px-12"
      data-testid="impact-strip"
    >
      <div className="mx-auto grid max-w-5xl grid-cols-1 gap-10 text-center sm:grid-cols-3 sm:gap-6">
        {STATS.map((s, i) => (
          <motion.div
            key={s.testid}
            data-testid={s.testid}
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="font-serif text-5xl font-light tracking-tight text-[#F8FAFC] sm:text-6xl" data-testid={`${s.testid}-value`}>
              <Counter value={s.value} suffix={s.suffix} run={inView} />
            </p>
            <p className="mt-3 font-mono text-[0.62rem] uppercase tracking-[0.24em] text-[#AEE6D5]">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
